// extracted by mini-css-extract-plugin
export default {"highlighted":"HighlightedText_highlighted__wyOse"};